import React from 'react';
import { useFormContext } from 'react-hook-form';
import { stripUrlSpaces, urlHasSpace } from '../../utils/validators';

// Inline "Fix" action shown next to a URL field's space-warning message: strips all whitespace
// and re-validates. Self-hides when the field value has no space. Pass as SingleLineField's
// `footer` so it renders on the same line as the (validation-driven) warning, in the input column.
const UrlSpaceFixButton: React.FC<{ name: string; disabled?: boolean }> = ({
  name,
  disabled = false,
}) => {
  const { watch, setValue } = useFormContext();
  const value: string = watch(name) || '';

  if (disabled || !urlHasSpace(value)) return null;

  const handleFix = () => {
    setValue(name, stripUrlSpaces(value), { shouldValidate: true, shouldDirty: true });
  };

  return (
    <button
      type="button"
      onClick={handleFix}
      className="ml-2 font-medium text-indigo-600 underline hover:text-indigo-800"
    >
      Remove space
    </button>
  );
};

export default UrlSpaceFixButton;
